import _ from 'lodash';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Switch from '@mui/material/Switch';
import Typography from '@mui/material/Typography';
import Collapse from '@mui/material/Collapse';
import Radio from '@mui/material/Radio';

import { ExpandMoreIcon, ExpandLessIcon } from '../../customStyles/images';
import { AntSwitch } from '../../customStyles/switch';


export const productListData = {
  productSelect: ({ header, rowData, handleTableAction, handleOtherInfo }) => {
    const { id } = header;
    const getSelectedProduct = handleOtherInfo({ id, data: rowData });

    return (
      <>
        <Radio
          name="product-radio-buttons"
          value={rowData.identity}
          checked={rowData?.identity === getSelectedProduct}
          onChange={(e) => {
            handleTableAction(e, { id, data: rowData })
          }}
        />
      </>
    )
  },
  userQuestionSummary: ({ header, rowData, isDropDown, setIsDropDown }) => {
    const { id } = header;
    const value = _.get(rowData, id);
    const limit = 200;

    return (
      <>
        {value?.length ? (
          <Stack variant='between-start'>
            <Box sx={{ maxWidth: '95%' }}>
              <Typography variant='body_sm' paddingTop='4px'>
                {isDropDown ? value : `${value.slice(0, limit)}${value.length > limit ? '...' : ''}`}
              </Typography>
            </Box>

            {value.length > limit && (
              <Box
                onClick={() => setIsDropDown(prev => !prev)}
                sx={{ cursor: 'pointer' }}
              >
                {isDropDown ? <ExpandLessIcon /> : <ExpandMoreIcon />}
              </Box>
            )}
          </Stack>
        ) : (
          '--'
        )}
      </>
    )
  },
}


